import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const CertificationSteps = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Certification Steps</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) provides a structured process for obtaining certification under its Industrial Research and Training division.
          </p>
          <p className="subtitle">
            These steps ensure organizations, products, and personnel meet national and international standards efficiently and transparently.
          </p>
        </div>
      </section>

      {/* === Certification Steps Section === */}
      <section className="intro-section">
        <h2 className="section-title">Steps to Obtain Certification</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Step 1: Application Submission – Submit a complete application with required documents</li>
              <li>Step 2: Document Review – MBS reviews submitted documents for completeness and compliance</li>
              <li>Step 3: Pre-assessment – Preliminary evaluation to identify gaps and requirements</li>
              <li>Step 4: On-site Assessment – Conduct audits or inspections to verify compliance</li>
              <li>Step 5: Evaluation & Reporting – Assess findings and prepare an evaluation report</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Step 6: Corrective Actions – Address any non-conformities identified during assessment</li>
              <li>Step 7: Certification Decision – MBS decides on certification based on compliance and readiness</li>
              <li>Step 8: Issuance of Certificate – Successful applicants receive a certification valid for a defined period</li>
              <li>Step 9: Surveillance & Monitoring – Regular follow-up audits to ensure continued compliance</li>
              <li>Step 10: Renewal – Apply for certification renewal before expiry to maintain status</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Certification</h2>
        <p>
          For inquiries, applications, or more information about the certification process, please contact the Industrial Research and Training Certification team at MBS.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:certification@mbs.mw">certification@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 777</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          Following these structured certification steps ensures transparency, compliance, and recognition for organizations and personnel in Malawi.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default CertificationSteps;
